import React, { memo, useCallback, useEffect, useState } from 'react';
import { Divider, Skeleton } from 'antd';

import { useClient } from '../../../../hooks/ClientProvider';
import { useVipage } from '../../../../hooks/useVipage/useVipage'; 
import { CreditCardV2 } from '../../../../components/CreditCardV2/CreditCardV2';
import { StatusCard } from '../../../../components/CreditCardV2/StatusCard';
import { ConfirmationModal } from '../../../../components/ConfirmationModal';

function CardsInTransition({
  reloadCards,
  reloadDependantCards,
  bloqCard,
  unBloqCard,
}) {
  const [cardsInTransition, setCardsInTransition] = useState([]);
  const [cardToConfirm, setCardToConfirm] = useState(null);

  const { client, refreshClientV2 } = useClient();
  const { 
    fetchTransitionCards, 
    updateProduct, 
    loadingCards, 
    loadingAction 
  } = useVipage();

  const fetchCardsInTransition = useCallback(async () => {
    const res = await fetchTransitionCards(client?.client?.id);

    if (res) {
      const cardsInTransitionFormatted = res.map((card) => ({
        ...card,
        nome: card.nomePortadorCartao,
        numeroMascarado: card.panMascarado,
        status: card.statusCartao,
        statusEmbossing: card.statusEmbossing,
        dataValidade: card.dataExpiracao,
        idProduto: client?.client?.produtoTransicaoBandeira?.id 
      }));

      setCardsInTransition(cardsInTransitionFormatted);
    }
  }, [client?.client?.id, client?.client?.produtoTransicaoBandeira?.id, fetchTransitionCards]);

  useEffect(() => {
    if (client?.client?.transicaoBandeira === 'T') {
      fetchCardsInTransition();
    }
  }, [client?.client?.transicaoBandeira, fetchCardsInTransition]);

  const reloadTransitionCard = useCallback(async () => {
    await fetchCardsInTransition();
  }, [fetchCardsInTransition]);

  const handleConfirmAction = async () => {
    if (!cardToConfirm) return;

    const success = await updateProduct({
      clientId: client?.client?.id,
      productId: client?.client?.produtoTransicaoBandeira?.id,
      cardNumber: cardToConfirm.numeroMascarado
    });

    if (success) {
      if (refreshClientV2) await refreshClientV2();
      await fetchCardsInTransition();
      if (reloadCards) await reloadCards();
      if (reloadDependantCards) await reloadDependantCards();
      setCardToConfirm(null); 
    }
  };

  return (
    <Skeleton loading={loadingCards}>
      {client?.client?.transicaoBandeira === 'T' &&
        !!cardsInTransition.length && <Divider><strong> Cartões em transição</strong></Divider>}
        
      {cardsInTransition?.map((card) => (
        <React.Fragment key={card?.id}>
          
          <CreditCardV2
            card={card}
            reloadCards={reloadTransitionCard}
            bloqCard={bloqCard}
            unBloqCard={unBloqCard}
            isDependent={client?.client?.adicional}
            isTransitionCard 
            onConfirmTransition={() => setCardToConfirm(card)}
          />
          
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <StatusCard card={card} />
          </div>

        </React.Fragment>
      ))}

      {cardToConfirm && (
        <ConfirmationModal
          title="Confirmar Transição"
          description="Tem certeza que deseja confirmar o recebimento e concluir a transição para o cartao bandeira?"
          isLoading={loadingAction}
          onClose={() => setCardToConfirm(null)} 
          onSubmit={handleConfirmAction}         
          submitText="Confirmar"
          cancelText="Cancelar"
        />
      )}
    </Skeleton>
  );
}

export default memo(CardsInTransition);
